import { render, staticRenderFns } from "./orderDetailItem.vue?vue&type=template&id=119b243e&scoped=true&"
import script from "./orderDetailItem.vue?vue&type=script&lang=js&"
export * from "./orderDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailItem.vue?vue&type=style&index=0&id=119b243e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b243e",
  null
  
)

export default component.exports